export default __webpack_public_path__ + "static/media/show-room.faeb8f12.svg";